module.exports = __webpack_public_path__ + "img/R14.78437057.png";